import gql from 'graphql-tag'



export const SAVE_TOPCOMMENT = gql`
         mutation saveTopComment(
           $topCommentId: String!
           $videoId: String!
           $makerChannelId: String!
           $makerChannelDisplayName: String!
           $makerChannelProfileImageUrl: String!
           $makerUpdatedAt: Date!
           $makerPublishedAt: Date!
           $categoryId: String!
           $likeCount: Int!
           $textOriginal: String!
         ) {
           saveTopComment(
             topCommentId: $topCommentId
             videoId: $videoId
             makerChannelId: $makerChannelId
             makerChannelDisplayName: $makerChannelDisplayName
             makerChannelProfileImageUrl: $makerChannelProfileImageUrl
             makerUpdatedAt: $makerUpdatedAt
             makerPublishedAt: $makerPublishedAt
             categoryId: $categoryId
             likeCount: $likeCount
             textOriginal: $textOriginal
           ) {
             id
             topCommentId
             videoId
             makerChannelId
             makerChannelDisplayName
             makerChannelProfileImageUrl
             makerUpdatedAt
             makerPublishedAt
             textOriginal
             likeCount
             category{
               id
               categoryCount
             }
           }
         }
       `;